export default __webpack_public_path__ + "static/media/img8.2944fb81.png";